import { Pipe, PipeTransform } from '@angular/core';

/**
 * @constant
 * @description The number of bytes in a gigabyte.
 * @export
 * @name ByteSizeGigabyte
 * @type {number}
 */
export const ByteSizeGigabyte : number = 1073741824;

/**
 * @constant
 * @description The number of bytes in a kilobyte.
 * @export
 * @name ByteSizeKilobyte
 * @type {number}
 */
export const ByteSizeKilobyte : number = 1024;

/**
 * @constant
 * @description The number of bytes in a megabyte.
 * @export
 * @name ByteSizeMegabyte
 * @type {number}
 */
export const ByteSizeMegabyte : number = 1048576;

/**
 *
 */
@Pipe({
  name: 'byteSize',
  standalone: true
})
export class ByteSizePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {

    // Check for gigabytes then return the value in gigabytes.
    if (value >= ByteSizeGigabyte) return `${(value / ByteSizeGigabyte).toFixed(2)} gb`;

    // Check for megabytes then return the value in megabytes.
    if (value >= ByteSizeMegabyte) return `${(value / ByteSizeMegabyte).toFixed(2)} mb`;

    // Check for kilobytes then return the value in kilobytes.
    if (value >= ByteSizeKilobyte) return `${(value / ByteSizeKilobyte).toFixed(2)} kb`;

    // Return the value in bytes.
    return `${value} b`;
  }

}
